var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarNotFilledv2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.36469 13.6787C8.97682 13.4892 8.52318 13.4892 8.13531 13.6787L5.32437 15.0524L4.01846 15.6906C3.55882 15.9152 3.04696 15.4984 3.17373 15.0028L4.12801 11.2721C4.24546 10.8129 4.12261 10.3255 3.80155 9.97679L0.693635 6.60168C0.353892 6.23273 0.58989 5.63454 1.09003 5.59694L5.48709 5.26635C5.99247 5.22836 6.43785 4.9202 6.65156 4.46066L8.20596 1.11837C8.42112 0.655725 9.07888 0.655726 9.29404 1.11837L10.8484 4.46066C11.0622 4.9202 11.5075 5.22836 12.0129 5.26635L16.41 5.59694C16.9101 5.63454 17.1461 6.23273 16.8064 6.60168L13.6984 9.97679C13.3774 10.3255 13.2545 10.8129 13.372 11.2721L14.3263 15.0028C14.453 15.4984 13.9412 15.9152 13.4815 15.6906L9.36469 13.6787Z",
    fill: "white",
    stroke: "#FFBF29",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarNotFilledv2);
export default __webpack_public_path__ + "static/media/star-not-filledv2.203d807ee7e99465463cb06b8c179c32.svg";
export { ForwardRef as ReactComponent };